const emojiMap = [
    { key: ":)", value: "😊" },
    { key: ":-)", value: "😊" },
    { key: ":D", value: "😃" },
    { key: ":-D", value: "😃" },
    { key: ":(", value: "☹️" },
    { key: ":-(", value: "☹️" },
    { key: ";)", value: "😉" },
    { key: ";-)", value: "😉" },
    { key: ":P", value: "😛" },
    { key: ":-P", value: "😛" },
    { key: ":p", value: "😛" },
    { key: ":-p", value: "😛" },
    { key: ":o", value: "😮" },
    { key: ":-o", value: "😮" },
    { key: ":'(", value: "😢" },
    { key: ":'-)", value: "😂" },
    { key: "XD", value: "😆" },
    { key: "xD", value: "😆" },
    { key: ":-*", value: "😘" },
    { key: ":*", value: "😘" },
    { key: "<3", value: "❤️" },
    { key: "</3", value: "💔" },
    { key: ":O", value: "😲" },
    { key: ":-O", value: "😲" }
];

const escapeRegExp = (string) => {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
};

export const convertTextToEmoji = (text) => {

    const regex = new RegExp(
        emojiMap.map(({ key }) => escapeRegExp(key)).join("|"),
        "g"
    );

    return text.replace(regex, (matched) => {
        const found = emojiMap.find(({ key }) => key === matched);
        return found ? found.value : matched;
    });
};

export const convertEmojiToText = (emoji) => {

    const regex = new RegExp(
        emojiMap.map(({ value }) => escapeRegExp(value)).join("|"),
        "g"
    );

    return emoji.replace(regex, (matched) => {
        const found = emojiMap.find(({ value }) => value === matched);
        return found ? found.key : matched;
    });
};